// removed by extract-text-webpack-plugin
module.exports = {"Base":"NewsletterModal__Base-2OpVS","ModalOverlay":"NewsletterModal__ModalOverlay-3pe8a","ModalContent":"NewsletterModal__ModalContent-2ZYMB","Close":"NewsletterModal__Close-3-bIl","Header":"NewsletterModal__Header-1Nv_G","Fieldset":"NewsletterModal__Fieldset-2UDa3","FormGroup":"NewsletterModal__FormGroup-2nXq0","H2":"NewsletterModal__H2-1X4DH","Label":"NewsletterModal__Label-39Jxk","Input":"NewsletterModal__Input-3XNiT","Input--email":"NewsletterModal__Input--email-1DSV6 NewsletterModal__Input-3XNiT","Button":"NewsletterModal__Button-2YD7X"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/NewsletterModal/NewsletterModal.css
 ** module id = 637
 ** module chunks = 0
 **/